/**
 * Enums for classifier property keys.
 * Note: when you update this, also look at ClassifierPropertyKey.php.
 */
enum ClassifierPropertyKey {
  REGISTRATION_NUMBER_REQUIRED = 'registration_number_required',
  ALLOW_TO_TYPE_NAME = 'allow_to_type_name',
  NEED_PERSONAL_CODE = 'need_personal_code',
  VALIDATE_ON_STATE_REVENUE_SERVICE = 'validate_srs',
  WIDTH_AND_UNIT = 'width_and_unit',
  SECTOR = 'sector',
  CROP_GROUP = 'crop_group',
  LIVESTOCK_SECTOR = 'livestock_sector',
  LAD_CODE = 'lad_code',
  LAD_CODE_SOWING = 'lad_code_sowing',
  PRODUCED = 'produced',
  PURCHASED = 'purchased',
  RECYCLED = 'recycled',
  RECORD_TYPE = 'record_type',
  PLANT_PROTECTION_PRODUCT_TYPE = 'plant_protection_product_type',
  FERTILIZER_TYPE = 'fertilizer_type',
  NAME = 'name',
  UNITS_OF_MEASURE = 'units_of_measure',
  BASE_HUMIDITY = 'base_humidity',
  VETERINARY_MEDICINAL_PRODUCT = 'veterinary_medicinal_product',
  ABBREVIATION = 'abbreviation',
  PLANT_DEVELOPMENT_STAGE = 'plant_development_stage',
  PLANT_DEVELOPMENT_STAGE_CATEGORY = 'plant_development_stage_category',
  PLANT_DEVELOPMENT_STAGE_DESCRIPTION = 'plant_development_stage_description',
  CROP_WORK_TYPE = 'crop_work_type',
  DELETE_FIELD_CROP = 'delete_field_crop',
  UPDATE_FIELD_CROP = 'update_field_crop',
  CHOOSE_CATEGORY_FOR_SPRAYING = 'choose_category_for_spraying',
  N = 'n',
  P2O5 = 'p2o5',
  K2O = 'k2o',
  CA = 'ca',
  MG = 'mg',
  NA = 'na',
  S = 's',
  B = 'b',
  CO = 'co',
  CU = 'cu',
  FE = 'fe',
  MN = 'mn',
  MO = 'mo',
  ZN = 'zn',
  CACO3 = 'caco3',
  N_CORRECTION_LAWN_SOWING = 'n_correction_lawn_sowing',
  P2O5_CORRECTION_LAWN_SOWING = 'p2o5_correction_lawn_sowing',
  K2O_CORRECTION_LAWN_SOWING = 'k2o_correction_lawn_sowing',
  N_CORRECTION_HARVEST_RESIDUES = 'n_correction_harvest_residues',
  P2O5_CORRECTION_HARVEST_RESIDUES = 'p2o5_correction_harvest_residues',
  K2O_CORRECTION_HARVEST_RESIDUES = 'k2o_correction_harvest_residues',
  N_CORRECTION_PRECURSOR_EFFECT = 'n_correction_precursor_effect',
  FERTILIZER = 'fertilizer',
  YEAR = 'year',
  PLANT_FOOD_ELEMENT = 'plant_food_element',
  CONTENT_IN_SOIL = 'content_in_soil',
  CONTENT_IN_SOIL_FROM_MG_KG = 'content_in_soil_from_mg_kg',
  CONTENT_IN_SOIL_UP_TO_MG_KG = 'content_in_soil_up_to_mg_kg',
  CORRECTION_FACTOR = 'correction_factor',
  GRANULOMETRIC_COMPOSITION_OF_THE_SOIL = 'granulometric_composition_of_the_soil',
  SOIL_ACIDITY_PH_KCL_FROM = 'soil_acidity_ph_kcl_from',
  SOIL_ACIDITY_PH_KCL_TO = 'soil_acidity_ph_kcl_to',
  N_CORRECTION = 'n_correction',
  N_CORRECTION_GRANULOMETRIC_COMPOSITION = 'n_correction_granulometric_composition',
  P2O5_CORRECTION_GRANULOMETRIC_COMPOSITION = 'p2o5_correction_granulometric_composition',
  K2O_CORRECTION_GRANULOMETRIC_COMPOSITION = 'k2o_correction_granulometric_composition',
  CROP = 'crop',
  YIELD_LEVEL_FROM_T_HA1 = 'yield_level_from_t_ha1',
  YIELD_LEVEL_TO_T_HA1 = 'yield_level_to_t_ha1',
  MAXIMUM_PERMISSIBLE_AMOUNT_OF_NITROGEN_KG_HA1 = 'maximum_permissible_amount_of_nitrogen_kg_ha1',
  STANDARD_CROP_T_HA = 'standard_crop_t_ha',
  N_NEED_FOR_STANDARD_HARVEST_KG_HA = 'n_need_for_standard_harvest_kg_ha',
  P2O5_NEED_FOR_STANDARD_HARVEST_KG_HA = 'p2o5_need_for_standard_harvest_kg_ha',
  K2O_NEED_FOR_STANDARD_HARVEST_KG_HA = 'k2o_need_for_standard_harvest_kg_ha',
  N_CORRECTION_FOR_EACH_TON_OF_YIELD_DEVIATION_FROM_THE_STANDARD_YIELD_KG_HA = 'n_correction_for_each_ton_of_yield_deviation_from_the_standard_yield_kg_ha',
  P2O5_CORRECTION_FOR_EACH_TON_OF_YIELD_DEVIATION_FROM_THE_STANDARD_YIELD_KG_HA = 'p2o5_correction_for_each_ton_of_yield_deviation_from_the_standard_yield_kg_ha',
  K2O_CORRECTION_FOR_EACH_TON_OF_YIELD_DEVIATION_FROM_THE_STANDARD_YIELD_KG_HA = 'k2o_correction_for_each_ton_of_yield_deviation_from_the_standard_yield_kg_ha',
  N_CORRECTION_MANURE = 'n_correction_manure',
  P2O5_CORRECTION_MANURE = 'p2o5_correction_manure',
  K2O_CORRECTION_MANURE = 'k2o_correction_manure',
  ORGANIC_MATTER_SOIL_CONTENT_PERCENT_FROM = 'organic_matter_soil_content_percent_from',
  ORGANIC_MATTER_SOIL_CONTENT_PERCENT_TO = 'organic_matter_soil_content_percent_to',
  CORRECTION_COEFFICIENT = 'correction_coefficient',
  PERIOD = 'period',
  DRY_MATTER = 'dry_matter',
  ANIMAL_GROUP = 'animal_group_code',
  ANIMAL_DRY_MATTER = 'animal_dry_matter',
  FEEDINGSTUFF = 'feedingstuff',
  FEEDINGSTUFF_EAT_LOSSES_PERC = 'feedingstuff_eat_losses_perc',
  FEEDINGSTUFF_STORAGE_LOSSES_PERC = 'feedingstuff_storage_losses_perc',
  NATURAL_FARMS_DRY_MATTER_RESTRICTION_PERC = 'natural_farms_dry_matter_restriction_perc',
  ANIMAL_TYPE = 'animal_type',
}

export default ClassifierPropertyKey;
